"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppForm = exports.StyledSampleWrapper = exports.StyledTitle = exports.StyledWrapper = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledWrapper = styled_components_1.default.form `
  position: relative;
  display: flex;
  flex-flow: column;
  flex: 1;

  textarea {
    padding-bottom: 62px;
    min-height: 200px;
  }
`;
exports.StyledTitle = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
  color: ${({ theme }) => theme.Color.Neutrals.Dark};
`;
exports.StyledSampleWrapper = styled_components_1.default.div `
  display: flex;
  position: absolute;
  width: calc(100% - ${({ theme }) => theme.Spacing.Size.Small * 2}px);
  bottom: ${({ theme }) => theme.Spacing.Size.Small}px;
  left: ${({ theme }) => theme.Spacing.Size.Small}px;
`;
function AppForm({ children, inputRef, labels, result, status, prompt = '', samplePrompts = [], showSubtitle, onPromptChange, onPromptSubmit, }) {
    const theme = (0, styled_components_1.useTheme)();
    const [currentPrompt, setCurrentPrompt] = (0, react_1.useState)(prompt);
    const onChangeHandler = (event) => {
        const value = event.target.value;
        setCurrentPrompt(value);
        onPromptChange(value);
    };
    const onSubmitHandler = (event) => {
        event.preventDefault();
        onPromptSubmit(currentPrompt);
    };
    (0, react_1.useEffect)(() => {
        setCurrentPrompt(prompt);
    }, [prompt]);
    return ((0, jsx_runtime_1.jsxs)(exports.StyledWrapper, { onSubmit: onSubmitHandler, children: [children, showSubtitle && ((0, jsx_runtime_1.jsx)(exports.StyledTitle, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: theme.Form.Input.Size, children: labels.subtitle }) })), (0, jsx_runtime_1.jsx)(ui_common_components_1.TextArea, { ref: inputRef, name: "ai-prompt", resize: 'none', placeholder: labels.promptPlaceholder, onChange: onChangeHandler, value: currentPrompt })] }));
}
exports.AppForm = AppForm;
//# sourceMappingURL=AppForm.js.map